export default "__VITE_ASSET__BqW7viTx__"